import { preventIEError } from '@neux/ui-jquery/tool';
import { apiData, baseUrl } from './config.js';
import mobileMenu from './mobileMenu.js';
import scrollUpShowHeader from './scrollUpShowHeader.js';
import { addOpenWindowText } from './util.js';

function initializePage() {
	const params = new URL(location.href).searchParams.get('id');
	const url = apiData[PROCESS.ENV]['newsDetail'] + '/' + params;
	$.ajax({
		url: url,
		method: 'GET',
		contentType: 'application/json; charset=utf-8',
		dataType: 'json'
	}).done((data) => {
		renderData(data.data);
	}).fail(() => {
		console.error('API failed:' + url);
	});
}

function main() {
	// init
	preventIEError();
	initializePage();

	// for api
	scrollUpShowHeader();
	mobileMenu();
}

function renderData(data) {
	if (!data) return false;

	// 修改title
	document.title = data.title;

	const titleBox = renderTitleBox(data.base_info);
	const imageBox = renderImageBox(data.base_info);
	const contentBox = renderContentBox(JSON.parse(data.content_json));
	const linkBox = renderLinkBox(data.links);
	const fileBox = renderFileBox(data.files);
	const backBtn = `<div class="news-back__content"><a href="./news.html" class="news-back__link">回列表</a></div>`;
	$('#news__container').html(titleBox + imageBox + contentBox + linkBox + fileBox + backBtn);
	bindDownloadEvent();
}

function getDay(date) {
	const week = ['日', '一', '二', '三', '四', '五', '六'];
	const day = new Date(date).getDay();
	return week[day];
}

function renderTitleBox(data) {
	return `
  <div class="news-title__content">
    ${data.type_name !== ''
			? `<div class="news__category">${data.type_name}</div>`
			: ''
		}
    
    <h1 class="news__title h4">${data.title}</h1>
    ${data.activity_start_time !== ''
			? `
       <div class="news-date__content">
        <div class="news-date__icon">
          <svg>
            <use xlink:href="#icon_date" /></svg>
        </div>
        <div class="news-date">${data.activity_start_time} (${getDay(data.activity_start_time)})</div>
        ${data.activity_end_time !== '' && data.activity_end_time !== null && data.activity_start_time !== data.activity_end_time
				? `<div class="news-date">${data.activity_end_time} (${getDay(data.activity_end_time)})</div>`
				: ''
			}
      </div>`
			: ''
		}
  </div>`;
}

function renderImageBox(data) {
	if (data.activity_picture) {
		return `
    <div class="news__image">
      <img src="${baseUrl[PROCESS.ENV] + data.activity_picture}" alt="${data.title}的圖片">
    </div>`;
	} else {
		return '';
	}
}

function renderContentBox(data) {
	const title = data.languages[0]?.blocks[0]?.templates[0]?.groupFields[0]?.fields[0][0]?.fieldVal;
	const titleHidden = data.languages[0]?.blocks[0]?.templates[0]?.groupFields[0]?.fields[0][0]?.hidden;
	const content = addOpenWindowText(data.languages[0]?.blocks[0]?.templates[0]?.groupFields[0]?.fields[0][1]?.fieldVal);
	if (title !== '' || content !== '') {
		return `
			<div class="news__content neux-editor">
			${titleHidden !== undefined && titleHidden
				? ''
				: title !== ''
					? `<div class="news-content__title">${title}</div>`
					: ''
			}
			${content}
			</div>
		`;
	} else {
		return '';
	}
}

function renderLinkBox(list) {
	if (list.length) {
		return `
    <div class="news-other__content">
      <h2 class="title-left-line">相關連結</h2>
      <ul class="news-related-link__list">
        ${list.map((item) => {
			return `
            <li class="news-related-link__item">
              <a
                href="${item.link.url !== '' ? item.link.url : 'javascript:;'}"
                target="${item.link.url_blank ? '_blank' : '_self'}"
                title="${item.title}${item.link.url_blank === true ? '(另開視窗)' : ''}"
                class="news-related-link__link"
              >
                <span class="news-related-link__icon">
                  <svg>
                    <use xlink:href="#icon_arrow-right" />
                  </svg>
                </span>${item.title}${item.link.url_blank === true ? '(另開視窗)' : ''}</a>
            </li>`;
		}).join('')
			}
      </ul>
    </div>`;
	} else {
		return '';
	}
}

function renderFileBox(list) {
	if (list.length) {
		return `
    <div class="news-other__content">
      <h2 class="title-left-line">相關檔案</h2>
      <div class="news-download__content">
        <ul class="news-download__list">
				${list.map((item) => {
			return `<li class="news-download__item">
                <h3 class="news-download__title">${item.title}</h3>
                <div class="news-download__button-box">
                  <button type="button" data-file="${item.file.url}" class="news-download__button" title="${item.title}的${item.file.file_type === 'PDF' ? 'PDF' : item.file.file_type === 'EXCEL' ? 'EXCEL' : ''}檔案瀏覽(另開視窗)" role="link">
                  ${item.file.file_type === 'PDF'
					? `<svg><use xlink:href="#icon_pdf" /></svg>`
					: item.file.file_type === 'EXCEL'
						? `<svg><use xlink:href="#icon_xls" /></svg>`
						: item.file.file_type === 'OTHERS'
							? `<svg><use xlink:href="#icon_cloud" /></svg>`
							: ''
				}
                  </button>
                </div> 
			</li>`;
		}).join('')
			}
        </ul>
      </div>
    </div>`;
	} else {
		return '';
	}

}

function bindDownloadEvent() {
	$('.news-download__button').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		const fileUrl = $(this).data('file');
		window.open(fileUrl, '_blank');
	});
}

main();